import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const ReadyEncodedCrossDeployCalldataSchema = z.object({
  readyEncodedCrossDeployCalldataValue: z.instanceof(HexNumber),
})

type ReadyEncodedCrossDeployCalldataProps = z.infer<
  typeof ReadyEncodedCrossDeployCalldataSchema
>

export class ReadyEncodedCrossDeployCalldata extends ValueObject<ReadyEncodedCrossDeployCalldataProps> {
  public getValue(): HexNumber {
    return this.props.readyEncodedCrossDeployCalldataValue
  }

  public static create(value: HexNumber): ReadyEncodedCrossDeployCalldata {
    const validatedProps = ReadyEncodedCrossDeployCalldataSchema.parse({
      readyEncodedCrossDeployCalldataValue: value,
    })
    return new ReadyEncodedCrossDeployCalldata(validatedProps)
  }
}
